<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{ title }}
			</h4>
		</div>
	</div>

	<div class="row mb-4">
		<!-- years list -->
		<div class="col-sm-6 col-md-2">
			<label for="year">{{'g.year' | translate}}</label>
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="yearList" bindLabel="label" bindValue="id" placeholder="{{'site.year' | translate}}" name="year" [(ngModel)]="selectedYear" (ngModelChange)="selectYear()" [clearable]="false">
			</ng-select>
		</div>

		<!-- Daily, Monthly or Quarterly drop-down -->
		<div class="col-sm-6 col-md-2" *ngIf="!isAllYearsSelected()">
			<label for="period">{{'perf_analytic.period' | translate}}</label>
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="periodTypes" bindLabel="label" bindValue="id"
				placeholder="{{'perf_analytic.period' | translate}}" name="period" [(ngModel)]="selectedPeriodType"
				(ngModelChange)="changePeriodType()" [clearable]="false">
			</ng-select>
		</div>
		
		<!-- charts toggle -->
		<div class="col-sm-6 col-md-2">
			<label for="chart">{{'g.charts' | translate}}</label>
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="chartsList" bindLabel="label" bindValue="id"
				placeholder="{{'g.chart' | translate}}" name="chart" [(ngModel)]="selectedCharts" [clearable]="false">
			</ng-select>
		</div>
		
		<!-- graphs filter -->
		<div class="col-sm-6 col-md-2" *ngIf="selectedPeriodType !== 'daily' && selectedPeriodType !== 'weekly'">
			<label for="data">{{'sim.data' | translate}}</label>
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="graphTypes" bindLabel="label" bindValue="id"
				placeholder="{{'perf_analytic.period' | translate}}" name="graph_type" [(ngModel)]="selectedGraphTypes"
				[clearable]="false">
			</ng-select>
		</div>
	</div>
	<div class="row mb-4 align-items-end">
		<!-- voltage filter -->
		<div class="col-sm-6 col-md-2" *ngIf="hasVoltageFilter">
			<label for="warning">{{'fleet_reports.battery_voltage' | translate}}</label>
			<ng-select
				[(ngModel)]="selectedBatteryVoltage"
				[items]="batteryVoltagesOptions"
				name="tags_filter"
				bindValue="value"
				bindLabel="label"
				[clearable]="false"
				(ngModelChange)="onVoltageFilter()"
			></ng-select>
		</div>

		<!-- capacity filter -->
		<div class="col-sm-6 col-md-2" *ngIf="hasCapacityFilter">
			<label for="capacity">{{'devices.battery_capacity' | translate}}</label>
			<ng-select
				[(ngModel)]="selectedBatteryCapacity"
				[items]="batteryCapacitiesOptions"
				name="tags_filter"
				bindValue="value"
				bindLabel="label"
				[clearable]="false"
				(ngModelChange)="onCapacityFilter()"
			></ng-select>
		</div>

		<!-- Manufacturer filter -->
		<div class="col-sm-6 col-md-2" *ngIf="hasManufacturerFilter">
			<label for="battery_manufacturer">{{"devices.battery_manufacturer" | translate}}</label>
			<ng-select
				class="select"
				[(ngModel)]="selectedBatteryManufacturer"
				[items]="batteryManufacturersOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(ngModelChange)="getChargerUsageChart()"
				[placeholder]="'devices.battery_manufacturer' | translate"
			></ng-select>
		</div>

		<!-- Vintage filter -->
		<div class="col-sm-6 col-md-2" *ngIf="hasVintageFilter">
			<label for="batteryVintageSelect">{{"devices.battery_vintage" | translate}}</label>
			<ng-select
				name="batteryVintageSelect"
				id="batteryVintageSelect"
				class="select"
				[multiple]="true"
				[items]="vintageOptionsDropdown"
				[addTag]="true"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.battery_vintage' | translate"
				[(ngModel)]="selectedBatteryVintage"
				(change)="batteryVintageSelectionChanged()"
			>
				<ng-template ng-label-tmp let-item="item" let-clear="clear">
					<span>
						<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
						<span class="ng-value-label">{{item.label}}</span>
					</span>
				</ng-template>
			</ng-select>
		</div>

		<div class="d-inline-flex ml-auto" *ngIf="!noData">
			<button  class="btn fa fa-print fa-lg" printTitle="{{'fleet_reports.daily_hourly_charger_usage_data' | translate}}" [useExistingCss]="true" printSectionId="daily_hourly_charger_usage_data" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportDataToCsv()"></button>
		</div>
	</div>

	<!-- charts -->
	<div id="daily_hourly_charger_usage_data" *ngIf="!noData">
		<app-print-filters [title]="title" [filters]="printFilters"></app-print-filters>
		<div class="row" *ngIf="['hours', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_hours[selectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_hours[selectedYear])"
				id="charge_hours"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_hours' : 'fleet_reports.average_hours') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_hours[selectedYear] : chartsData.average_hours[selectedYear]"
				[columnNames]="timeChartColumns"
				[options]="timeChartConfig"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['ah', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_ah[selectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_ah[selectedYear])"
				id="charge_ah"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_ah' : 'fleet_reports.average_ah') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_ah[selectedYear] : chartsData.average_ah[selectedYear]"
				[columnNames]="ahChartColumns"
				[options]="chartObject.config"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
	</div>

	<div class="card-body" *ngIf="noData">
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</div>
</div>

